<template>
  <div class="login-page">
    <Nav :search="false" :car-btn="false" :phone="false" content>
      <div slot="content" class="toptip">
        <!-- <router-link :to="LinkTypeCode.Home">新手指南</router-link>
        <router-link :to="LinkTypeCode.Home">售后帮助</router-link>
        <router-link :to="LinkTypeCode.Home">常见问题</router-link>
        <router-link :to="LinkTypeCode.Home">关于我们</router-link> -->
        <!-- <span>服务热线：{{lang.Basic.ServicePhone}}</span> -->
      </div>
    </Nav>
    <div v-if="!isLogined" class="login">
      <van-form>
        <div class="login-content">
          <img src="../assets/login/login1.png">
          <!-- <div style="height: 474px;"> -->
          <div class="logins">
            <div class="title">欢迎使用药约約</div>
            <van-field
              v-model="login.phone"
              :placeholder="lang.Login.PhoneTip"
              :label="lang.Basic.Phone"
              type="tel"
              maxlength="11"
              :rules="[{ validator: valiPhone }]"
              :style="{
                boxShadow: phoneonFocus ? '0px 2px 6px 0px #4e4e4e' : 'inherit',
              }"
              @focus="
                (e) => {
                  phoneonFocus = true
                  onFocus(e)
                }
              "
              @blur="phoneonFocus = false"
            >
              <img slot="label" src="../assets/login/phone.png" width="17px">
            </van-field>
            <div v-if="loginErr.phone" class="pboneError">
              {{ loginErr.phone }}
            </div>

            <div v-if="!showPass" class="phone-veri">
              <van-field
                v-model="login.code"
                maxlength="6"
                :placeholder="lang.Login.VerificationTip"
                :label="lang.Basic.Verification"
                type="text"
                style="width:205px"
                :rules="[{ validator: valiCode }]"
                :style="{
                  boxShadow: phoneveriFocus
                    ? '0px 2px 6px 0px #4e4e4e'
                    : 'inherit',
                }"
                @focus="phoneveriFocus = true"
                @blur="phoneveriFocus = false"
                @keyup.enter="onLogin"
              >
                <img slot="label" src="../assets/login/ver.png" width="17px">
              </van-field>
              <van-button
                class="sendVeri"
                style="width:calc(100% - 245px);padding:0;"
                :loading="isSending"
                :disabled="countDown.timer != null"
                @click="getVerification"
              >
                {{
                  countDown.timer
                    ? `${lang.Login.VerificationReGet}(${countDown.time}s)`
                    : lang.Login.VerificationGet
                }}</van-button>
              <div v-if="loginErr.code" class="pboneError" style="top:240px">
                {{ loginErr.code }}
              </div>
            </div>

            <van-field
              v-else
              v-model="login.password"
              type="password"
              placeholder="请输入密码"
              label="登录密码"
              @focus="onFocus"
              @keyup.enter="onLogin"
            >
              <img slot="label" src="../assets/login/lock.png" width="17px">
            </van-field>
            <div v-if="loginErr.password" class="pboneError" style="top:240px">
              {{ loginErr.password }}
            </div>

            <van-button
              class="btnSubmit"
              :disabled="!checked"
              native-type="submit"
              :loading="isLoging"
              @click="onLogin"
            >
              {{ lang.Basic.BtnLogin }}</van-button>

            <van-checkbox
              v-model="checked"
              class="square"
              shape="square"
            >已同意<a
              href="/UserAgreement.html"
              target="_blank"
            >《用户协议》</a>及<a
              href="/PrivacyPolicy.html"
              target="_blank"
            >《隐私政策》</a></van-checkbox>

            <!-- <div class="regTip">注册账号请联系客服：{{lang.Basic.ServicePhone}}</div> -->
          </div>
          <!-- </div> -->
        </div>

        <div v-if="isShowRegister" class="btn-register">
          <span @click="turnPass">{{
            !showPass ? '密码登录' : '验证码登录'
          }}</span>
          |
          <span @click="goRegister">立即{{ lang.Basic.BtnRegister }}</span>
        </div>
      </van-form>
    </div>
    <SwitchStore
      ref="SwitchStore"
      :show-cancel="true"
      @confirm="onConfirm"
    />
    <Footer v-if="!isLogined" simple />
    <div v-if="isLogined && firstRequireFail" style="margin-top:10vh">
      <p>获取门店失败</p>
      <van-button
        color="#0F6EEA"
        :disabled="isLoging"
        @click="handleGetCustomers"
      >
        <template />
        {{
          isLoging
            ? '获取中...'
            : autoGet > 0
              ? timeout + 's后获取'
              : '重新获取'
        }}</van-button>
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '@/dictionary/base.js'
export default {
  name: 'Login',
  noNeedAuth: true,
  data() {
    return {
      LinkTypeCode,
      login: { phone: '', code: '', password: '' },
      loginErr: { phone: '', code: '', password: '' },
      checked: false,
      countDown: { timer: null, time: 0 },
      showPass: false,
      isSending: false,
      isLoging: false,
      customerList: [],
      selectedCustomerText: null,
      selectedCustomer: {},
      isShowRegister: false,
      phoneonFocus: false,
      phoneveriFocus: false,
      // 记录登录信息
      loginData: {
        Token: false,
        CustomerId: false,
        ContactsId: false
      },
      url: {
        send: '/clientapi_customer/Login/SendPhoneMessage',
        login: '/clientapi_customer/Login/Login',
        passlogin: '/clientapi_customer/Login/LoginByPassword',
        customers: '/api_customers/Customer/GetByContact',
        selectCustomer: '/clientapi_contacts/Contacts/SelectCustomer',
        getShowRegisterConfig:
          '/api_admin/GlobalConfig/DetailByKey?key=IsAllowCustomerAppRegister',
        sys: '/api_coupons/CouponPackage/SysSendCoupon'
      },
      isLogined: false,
      firstRequireFail: false,
      timeout: 5,
      timer: null,
      autoGet: 1
    }
  },
  mounted() {
    this.loginData = this.auth.getLoginDatas()
    const { Token, CustomerId, ContactsId } = this.loginData
    this.isLogined = !!Token
    if (!Token) {
      // 获取登录手机号
      const phone = this.$auth.getLoginPhone()
      this.login.phone = phone || ''
      return
    }
    if (!CustomerId || !ContactsId) {
      this.getCustomers(Token)
    } else {
      this.onConfirm()
    }
  },
  methods: {
    valiPhone(val) {
      if (/^0?1[0-9]\d{9}$/.test(val)) {
        this.loginErr.phone = ''
        return true
      }
      this.loginErr.phone = '请输入正确的手机号码'
      return true
    },
    valiCode(val) {
      if (val.length == 6) {
        this.loginErr.code = ''
        return true
      }
      this.loginErr.code = '请输入正确的验证码'
      return true
    },
    turnPass() {
      // this.showPass = !this.showPass;
    },
    onFocus(e) {
      e.srcElement.select()
    },
    async sysSendCoupon() {
      await this.getAction(this.url.sys)
    },

    goRegister() {
      this._go('Register')
    },

    /**
     * 获取手机验证码
     */
    async getVerification() {
      if (!this.hys.ValidatePhone(this.login.phone, 1)) {
        this.$message.error(this.lang.Login.ErrorPhoneTip)
        // this.$toast({
        //   position: 'bottom',
        //   message: this.lang.Login.ErrorPhoneTip,
        // })
        return
      }

      this.isSending = true
      const res = await this.getAction(this.url.send, {
        phone: this.login.phone
      })
      this.isSending = false

      if (!res.IsSuccess) {
        this.$message.error(res.Msg)
        // this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      if (this.countDown.time > 0) {
        return
      }
      this.countDown.time = 60
      const _this = this
      this.countDown.timer = setInterval(() => {
        _this.countDown.time--
        if (_this.countDown.time <= 0) {
          clearInterval(_this.countDown.timer)
          _this.countDown.time = 0
          _this.countDown.timer = null
        }
      }, 1000)
      // this.$toast({ position: 'bottom', message: '发送成功' })
      this.$message.success('发送成功')
    },
    /**
     * 登录按钮功能
     */
    async onLogin() {
      if (!this.checked) {
        this.$message.error('必须同意“用户协议及隐私政策”方可继续使用')
        // this.$toast({
        //   position: 'bottom',
        //   message: '必须同意“用户协议及隐私政策”方可继续使用',
        // })
        return
      }
      if (!this.hys.ValidatePhone(this.login.phone, 1)) {
        this.$message.error(this.lang.Login.ErrorPhoneTip)
        // this.$toast({
        //   position: 'bottom',
        //   message: this.lang.Login.ErrorPhoneTip,
        // })
        return
      }
      if (!this.showPass && (!this.login.code || this.login.code.length != 6)) {
        this.$message.error('验证码输入错误')
        // this.$toast({ position: 'bottom', message: '验证码输入错误' })
        return
      }
      if (this.showPass && !this.login.password) {
        this.$message.error('请输入密码')
        // this.$toast({ position: 'bottom', message: '请输入密码' })
        return
      }

      // 登录信息
      this.isLoging = true
      const res = await this.getAction(
        this.showPass ? this.url.passlogin : this.url.login,
        this.login
      )
      this.isLoging = false
      if (!res.IsSuccess) {
        this.auth.removeLoginDatas()
        this.$message.error(res.Msg)
        // this.$toast({ position: 'bottom', message: res.Msg })
        return
      }

      this.sysSendCoupon()

      // 保存登录手机号
      this.$auth.setLoginPhone(this.login.phone)
      const token = res.Data.AccessToken
      this.login.Token = token
      this.auth.setToken(token)
      this.auth.setUserId(res.Data.UserId)
      this.isLogined = true
      // 获取客户信息的步骤
      await this.getCustomers()
      // this.onConfirm()
    },
    // 自动获取客户信息
    autoGetCustomers() {
      const _self = this
      if (_self.timeout < 6 && _self.timeout > 0) {
        _self.timer = setTimeout(() => {
          _self.timeout--
          _self.autoGetCustomers()
        }, 1000)
      } else {
        _self.getCustomers()
        clearInterval(_self.timer)
        _self.timer = null
        _self.timeout = 5
        _self.autoGet--
      }
    },
    handleGetCustomers() {
      clearInterval(this.timer)
      this.timer = null
      this.autoGet = 0
      this.getCustomers()
    },
    /**
     * 获取客户信息
     */
    async getCustomers(isAuto) {
      this.$hys.openLoading()
      this.isLoging = true
      const res = await this.getAction(this.url.customers)
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.firstRequireFail = true
        if (this.autoGet > 0 && (this.timeout == 0 || this.timeout == 5)) {
          this.autoGetCustomers()
        }
        // this.auth.removeLoginDatas()
        this.$message.error(res.Msg)
        // this.$toast({ position: 'bottom', message: res.Msg })
        this.isLoging = false
        return
      }
      const customers = res.Data
      if (!customers || customers.length == 0) {
        this.auth.removeLoginDatas()
        this.$message.error(this.lang.Login.ErrorCustomerTip)
        // this.$toast({
        //   position: 'bottom',
        //   message: this.lang.Login.ErrorCustomerTip,
        // })
        this.isLoging = false
        return
      }
      this.customerList = customers
      const curList = this.customerList.filter(
        (tag) => tag.Id == this.auth.getCustomerId()
      )
      if (this.auth.getCustomerId() && curList.length > 0) {
        await this.$refs.SwitchStore.onConfirmCustomer(curList[0])
        this.auth.setCustomerInfo(curList[0])
        return
      }
      if (customers.length == 1) {
        await this.$refs.SwitchStore.onConfirmCustomer(customers[0])
        this.auth.setCustomerInfo(customers[0])
        return
      }
      this.$refs.SwitchStore.Show(this.customerList)
    },
    onConfirm() {
      let url = this.$route.query.redirect
      if (url == undefined || url == null || !url) {
        url = '/'
      }
      console.log({ url })
      this.$router.push(url)
      this.isLoging = false
    }
  }
}
</script>

<style lang="less">
.login-page {
  .login {
    height: 600px;
    // background: url(../assets/login/bg.png) no-repeat;
    // background-size: 100% 100%;
    // background-attachment: fixed;
    background: linear-gradient(
      270deg,
      rgba(9, 13, 88, 1) 0%,
      rgba(6, 10, 73, 1) 100%
    );
    box-sizing: border-box;
    position: relative;

    .pboneError {
      position: absolute;
      left: 30px;
      top: 158px;
      color: #ff4d34;
      font-size: 12px;
    }

    &-content {
      width: 1200px;
      height: 700px;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > img {
        width: 800px;
      }

      .logins {
        width: 400px;
        height: 414px;
        background: rgba(73, 79, 161, 1);
        border-radius: 1px;
        text-align: center;
        position: relative;

        a {
          /* 未访问的链接 */
          &:link {
            color: #b1e2ff;
            text-decoration: none;
          }

          /* 已访问的链接 */
          &:visited {
            color: #b1e2ff;
            text-decoration: line-through;
          }

          /* 鼠标移动到链接上 */
          &:hover {
            color: #e7f6ff;
          }

          /* 选定的链接 */
          &:active {
            color: #b1e2ff;
          }
        }

        .title {
          font-size: 24px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 33px;
          padding-top: 40px;
          box-sizing: border-box;
        }

        .van-cell {
          margin-top: 30px;
          margin-left: 30px;
          padding: 13px 16px;
          width: ~'calc(100% - 60px)';
          border-radius: 1px;
          box-sizing: border-box;

          .van-cell__title {
            width: 32px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
          }
        }

        .phone-veri {
          margin-left: 30px;
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          > .van-cell {
            margin: 0;
            box-sizing: border-box;
          }

          > .sendVeri {
            margin-right: 30px;
            height: 50px;
            background: linear-gradient(360deg, #1e63eb 0%, #4a92f1 100%);
            border-radius: 2px;
            border: none;
            font-size: 18px;
            color: #ffffff;
            box-sizing: border-box;

            &:disabled {
              background: linear-gradient(
                323deg,
                #ededed 0%,
                #e9e9e9 39%,
                #f5f5f5 100%
              );
              opacity: 1;
              color: #6a7786;
              font-size: 16px;
            }
          }
        }

        > .btnSubmit {
          margin-top: 60px;
          width: 340px;
          height: 46px;
          background: linear-gradient(360deg, #1e63eb 0%, #4a92f1 100%);
          border-radius: 23px;
          border: none;
          font-size: 18px;
          color: #ffffff;
          box-sizing: border-box;

          &:disabled {
            background: rgba(128, 183, 255, 1);
            opacity: 1;
          }
        }

        .square {
          margin-top: 20px;
          margin-left: 40px;
          box-sizing: border-box;

          .van-checkbox__icon {
            background: rgba(255, 255, 255, 1);
            box-shadow: inset 0px 0px 3px 0px rgba(202, 202, 202, 0.5);
            border-radius: 1px;
            border: 1px solid rgba(232, 232, 232, 1);
          }

          .van-checkbox__icon--checked {
            color: #fff;
            background-color: #1989fa;
            border-color: #1989fa;
          }

          .van-icon {
            border: none;
          }

          .van-checkbox__label {
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
            box-sizing: border-box;
          }
        }

        .regTip {
          font-size: 14px;
          text-align: right;
          margin-right: 10px;
          margin-top: 5px;
          color: #ffffff;
        }
      }
    }
  }

  .toptip {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px;
    color: #222222;
    font-weight: normal;

    > a {
      margin-right: 15px;
      margin-left: 15px;

      /* 未访问的链接 */
      &:link {
        color: #222222;
        text-decoration: none;
      }

      /* 已访问的链接 */
      &:visited {
        color: #222222;
        text-decoration: line-through;
      }

      /* 鼠标移动到链接上 */
      &:hover {
        color: #222222;
      }

      /* 选定的链接 */
      &:active {
        color: #222222;
      }
    }

    span {
      margin-left: 15px;
      color: #0f6ee9;
    }
  }
}
</style>
